// extracted by mini-css-extract-plugin
module.exports = {"root":"Map_root__Ser5c","mapRoot":"Map_mapRoot__3P0NA","staticMapRoot":"Map_staticMapRoot__-ZMDK"};